import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import PayeeDetailsPage, { getDefaultData } from "components/pages/PayeeDetailsPage";
import Classes, { Payee } from "model";

/**
 * @name CaptureWirePayeesAccountNumber
 * @returns {React.Component}
 * @description - A capture in capture group "Wire Payees".
 */
export default function CaptureWirePayeesAccountNumber(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const payee = Payee.init({
        payeeType: "domestic",
        addressType: "Domestic",
        financialInstitutionNumberType: "aba",
        nickname: "John Adams",
        name: "John Adams",
        email: "jadams@sample.com",
        account: "123456789",
    });

    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "payee" ], payee)
    .submit();

    return <PayeeDetailsPage data={ data } />;
}